module.exports = __webpack_public_path__ + "icon-6.png?80885ad0a3938af578f95506836556fd";